<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-6">
    <div class="card lg:h-34rem">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.tenantInfo' | transloco}}</h4></div>
      <hr>
      <table *ngIf="tenant" class="details-table striped-table">
        <tr>
          <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
          <td class="pr-1">
            <app-clipboard-label [value]="tenant.uuid" [copiedValue]="tenant.uuid"></app-clipboard-label>
          </td>
        </tr>
        <tr><td class="p-3 bold">{{'attribute.entryDate' | transloco}}</td><td>{{tenant.entryDate | customDate}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.expirationDate' | transloco}}</td><td>{{tenant.expirationDate | customDate}}</td></tr>
      </table>
      <app-table-skeleton *ngIf="!tenant" [rows]="8"></app-table-skeleton>
    </div>
  </div>
  <div class="col-12 lg:col-6">
    <div class="card lg:h-34rem">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.contactDetails' | transloco}}</h4></div>
      <hr>
      <table *ngIf="tenant" class="details-table striped-table">
        <tr><td class="p-3 bold">{{'attribute.email' | transloco}}</td><td>{{tenant.email}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.phone' | transloco}}</td><td>{{tenant.phone}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.address' | transloco}}</td><td>{{tenant.address}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.address2' | transloco}}</td><td>{{tenant.address2}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.city' | transloco}}</td><td>{{tenant.city}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.zip' | transloco}}</td><td>{{tenant.zip}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.region' | transloco}}</td><td>{{tenant.region}}</td></tr>
        <tr><td class="p-3 bold">{{'attribute.country' | transloco}}</td><td>{{tenant.country}}</td></tr>
      </table>
      <app-table-skeleton *ngIf="!tenant" [rows]="8"></app-table-skeleton>
    </div>
  </div>
</div>
